import lnArgos from '@jsluna/tokens/dist/argos/js/style/index.js'
import layers from '../global/scss/_layers.scss'
import variables from './scss/_variables.scss'

const ArgosTheme = {
  ...layers,
  ...variables,
  tokens: lnArgos
}

export default ArgosTheme
